import { Colors } from './types';

export const baseColors = {
  alert: '#D14020',
  active: '#2A9D8F',
  white: '#FFFFFF',
  white05: 'rgba(255, 255, 255, 0.05)',
  white10: 'rgba(255, 255, 255, 0.1)',
  white60: 'rgba(255, 255, 255, 0.6)',
  white87: 'rgba(255, 255, 255, 0.87)',
  gray: '#121212',
  gray60: '#12121299',
  gray30: '#12121261',
  hover1: '#121212',
  hover2: '#121212',
  d1: '#191919',
  d3gray: '#a5a5a5',
  d4: '#e8e8e8',
  d5: '#f1f1f1',
  toast: {
    dangerBg: '#FCF5F4',
    dangerFont: '#D14020',
    successBg: '#f8fdfb',
    successFont: '#2a9d8f'
  }
};

export const lightColors: Colors = {
  ...baseColors,
  primary: '#3B3C43',
  primary2: '#3B3C43',
  primaryHover: '#3B3C43',
  onPrimary: '#FFFFFF',
  secondary: '#94FFCA',
  onSecondary: '#121212DE',
  background: '#3B3C43',
  background2: '#F6F6F6',
  background3: '#EEEEEE',
  surface: '#FFFFFF',
  elevation1: '#3B3C43',
  elevation2: '#3B3C430D',
  elevation3: '#3B3C431C',
  elevation4: '#3B3C4329',
  onBackgroundAndElavation: '#E9E9EA',
  confPanel: '#8b286b',
  font1: '#191919',
  font2: '#FFFFFF',
  font3: '#191919',
  font4: '#FFFFFF',
  modal: '#FFFFFF',
  timeline: {
    optionsHover: '#a5a5a5',
    lineColor: '#121212',
    indicator: '#121212',
    label: '#121212',
    name: '#3B3C43'
  },
  table: {
    tableHeader: '#EEEEEE',
    fontColor: '#212529',
    rowHover: '#f1f1f1',
    row: '#FFFFFF',
    oddRow: 'rgba(216, 216, 216, 0.2)'
  }
};

export const darkColors: Colors = {
  ...baseColors,
  primary: '#E3E3E3',
  primary2: '#FFFFFF',
  primaryHover: '#BE5925',
  onPrimary: '#FFFFFF',
  secondary: '#94FFCA',
  onSecondary: '#121212DE',
  background: '#E9E9EA',
  background2: '#373B40',
  background3: '#65686B',
  surface: '#FFFFFF',
  elevation1: '#3B3C43',
  elevation2: '#3B3C430D',
  elevation3: '#3B3C431C',
  elevation4: '#3B3C4329',
  onBackgroundAndElavation: '#E9E9EA',
  confPanel: '#94ffc9',
  font1: '#FFFFFF',
  font2: '#373B40',
  font3: '#a5a5a5',
  font4: '#FFFFFF',
  modal: '#3B3C43',
  timeline: {
    optionsHover: 'rgba(255, 255, 255, 0.1)',
    lineColor: 'rgba(255, 255, 255, 0.38)',
    indicator: '#FFFFFF',
    label: 'rgba(255, 255, 255, 0.6)',
    name: 'rgba(255, 255, 255, 0.87)'
  },
  table: {
    tableHeader: 'transparent',
    fontColor: 'rgba(255, 255, 255, 0.87)',
    rowHover: '#35363a',
    row: 'transparent',
    oddRow: '#45464C'
  }
};
